<h1 mat-dialog-title class="title">Rate Us</h1>
<div mat-dialog-content class="dialog-content-container">
    <form class="rating-widget">
        <input type="checkbox" class="star-input" id="1" />
        <label class="star-input-label" for="1">1
            <i class="fa fa-star"></i>
            <i class="fa fa-star orange"></i>
        </label>
        <input type="checkbox" class="star-input" id="2" />
        <label class="star-input-label" for="2">2
            <i class="fa fa-star"></i>
            <i class="fa fa-star orange"></i>
        </label>
        <input type="checkbox" class="star-input" id="3" />
        <label class="star-input-label" for="3">3
            <i class="fa fa-star"></i>
            <i class="fa fa-star orange"></i>
        </label>
        <input type="checkbox" class="star-input" id="4" />
        <label class="star-input-label" for="4">4
            <i class="fa fa-star"></i>
            <i class="fa fa-star orange"></i>
        </label>
        <input type="checkbox" class="star-input" id="5" />
        <label class="star-input-label" for="5">5
            <i class="fa fa-star"></i>
            <i class="fa fa-star orange"></i>
        </label>
    </form>
</div>